var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterTypeAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M5.417 7.033a.44.44 0 0 0-.477.095L3.756 8.313H2.625a.437.437 0 0 0-.437.437v2.188a.44.44 0 0 0 .437.437h1.131L4.94 12.56a.437.437 0 0 0 .747-.31V7.438a.44.44 0 0 0-.27-.405m-.604 4.161-.566-.566a.44.44 0 0 0-.31-.128h-.874V9.188h.874a.44.44 0 0 0 .31-.128l.566-.566zm3.5-1.35a2.22 2.22 0 0 1-1.094 1.909.437.437 0 0 1-.438-.756 1.34 1.34 0 0 0 0-2.307.437.437 0 0 1 .438-.755 2.22 2.22 0 0 1 1.093 1.909m3.371-5.341L8.623 1.44a.44.44 0 0 0-.31-.127h-5.25a.875.875 0 0 0-.874.875v4.374a.437.437 0 1 0 .874 0V2.189h4.813v2.625a.437.437 0 0 0 .438.437h2.624v6.563h-1.75a.438.438 0 0 0 0 .874h1.75a.875.875 0 0 0 .876-.874v-7a.44.44 0 0 0-.129-.31M8.75 2.806l1.569 1.569H8.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTypeAudio);
export default __webpack_public_path__ + "static/media/filter-type-audio.827ab5853a7379822d14155326b1eb5b.svg";
export { ForwardRef as ReactComponent };